const LEGACY_PUBLIC_BUCKET_URL = 'https://public-bucket-orphex.s3.eu-central-1.amazonaws.com/'

const DIRECT_IMAGE_URL = /^(?:https?:|data:|\/)/i

/**
 * Resolve the account profile-picture value returned by bootstrap.
 *
 * Current payloads may carry either a browser-ready URL or the legacy public-bucket object key.
 * Unknown non-string values stay absent so AccountArea can retain its initials fallback.
 */
export function resolveProfilePictureUrl(value: unknown): string | null {
  if (typeof value !== 'string') return null

  const candidate = value.trim()
  if (!candidate) return null
  if (DIRECT_IMAGE_URL.test(candidate)) return candidate

  return `${LEGACY_PUBLIC_BUCKET_URL}${candidate}`
}
